import { Injectable } from '@angular/core';
import { Sc3FailedMessagesListSearchCriteria } from '../../models';
import { API_URL } from '../../../../../../services/config';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { FailedMessagesEndpoint } from '../../constants/failed-messages-endpoint';
import { isEmpty } from 'lodash';
import { removeEmptyValueFromObj } from '../../../../../../common';

@Injectable({
  providedIn: 'root',
})
export class Sc3FailedMessagesExportService {
  constructor(private http: WrapperHttpService) {}

  startExportToFile({
    searchCriteria,
    reportName,
  }: {
    searchCriteria: Sc3FailedMessagesListSearchCriteria;
    reportName: string;
  }): Observable<void> {
    const url = `${API_URL}${FailedMessagesEndpoint.Base}${FailedMessagesEndpoint.Sc3}${FailedMessagesEndpoint.Exports}`;
    const { size: _size, page: _page, ...rest } = searchCriteria;
    const transactionDateTime = removeEmptyValueFromObj({
      ...rest.transactionDateTime,
      start: rest.transactionDateTime?.start ? new Date(rest.transactionDateTime.start).getTime() : null,
      end: rest.transactionDateTime?.end ? new Date(rest.transactionDateTime.end).getTime() : null,
    });
    const filter = removeEmptyValueFromObj({
      ...rest,
      transactionDateTime: isEmpty(transactionDateTime) ? null : transactionDateTime,
    });
    return this.http.withLoading().post<void>(url, { reportName, filter });
  }
}
